import {
  initialState,
  Actions,
  State,
  DELETE_ELEMENT,
  DELETE_ELEMENT_SUCCESS,
  DELETE_ELEMENT_ERROR,
  RESET_DELETE_ELEMENT,
} from '../../types/element/delete'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_ELEMENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_ELEMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_ELEMENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_ELEMENT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
